import React from "react";
import ProgressBar from "../components/get-started/ProgressBar";
import PricingCard from "../components/get-started/PricingCard";

const pricingPlans = [
  {
    title: "Starter",
    price: "$99/mo",
    features: [
      "Basic analytics dashboard",
      "Up to 1,000 monthly users",
      "Email support",
      "Basic reporting",
    ],
  },
  {
    title: "Professional",
    price: "$199/mo",
    features: [
      "Advanced analytics",
      "Up to 10,000 monthly users",
      "Priority support",
      "Custom reporting",
      "API access",
    ],
  },
  {
    title: "Enterprise",
    price: "$499/mo",
    features: [
      "Full analytics suite",
      "Unlimited users",
      "24/7 dedicated support",
      "Custom solutions",
      "API access",
      "White-label options",
    ],
  },
];

const GetStarted: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400">
      <ProgressBar />
      <div className="container mx-auto px-6 pt-32 pb-20">
        <div className="text-center mb-16">
          <h1 className="desktop:text-5xl laptop:text-4xl tablet:text-3xl mobile:text-2xl font-bold text-white mb-6">
            Choose Your Plan
          </h1>
          <p className="desktop:text-xl laptop:text-lg tablet:text-base mobile:text-sm text-white/90">
            Select the perfect plan for your business needs
          </p>
        </div>

        <div className="grid desktop:grid-cols-3 laptop:grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1 gap-8">
          {pricingPlans.map((plan, index) => (
            <PricingCard
              key={plan.title}
              title={plan.title}
              price={plan.price}
              features={plan.features}
              delay={index * 0.2}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
